// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"select-wrapper__3Gnfa","label":"label__C_jzg","body":"body__7SWhp","select":"select__28Iaq"};